<template>
    <b-container id="confirmation-warning">
        <b-row>
            <b-container>
                <b-row align-v="center">
                    <b-col cols="9">
                        <slot>
                            <p>
                                You are about to update
                                <b>{{ numberOfItems}}</b> actions.<br>
                                Please click to confirm you wish to proceed.
                            </p>
                        </slot>
                    </b-col>
                    <b-col>
                        <b-btn
                                @click="unlock"
                                :variant=" unlocked ? 'white' : 'outline-white'"  size="md">
                            <font-awesome-icon
                                    :icon="unlocked
                                     ? ['fas', 'lock-open']
                                     : ['fas', 'lock']"
                            ></font-awesome-icon>
                        </b-btn>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'Confirmation-Warning',
  props: {
    numberOfItems: {
      type: Number,
    },
  },
  data() {
    return {
      unlocked: false,
    };
  },
  methods: {
    unlock() {
      this.unlocked = true;

      this.$emit('unlocked', true);
    },
  },
};
</script>

<style lang="scss">
    #confirmation-warning {
        border: 1px solid darken($red, 10%);
        border-radius: 0.25rem;
        padding: 15px;
        color: $white;
        width: 75%;
        background: $red;
        margin-top: 15px;

        p {
            font-size: 13px;
            display: inline;
            margin-right: 16px;
        }

        input {
            vertical-align: text-bottom;
        }
    }
</style>
